import { createSelector } from 'reselect'
import * as SelectorUtils from './utils'
import {
  DefaultTrackerIdState,
  DefaultTrackerPrimaryEntityState,
  DefaultTrackerTeasersAndTrailersState,
  DefaultWhatsNewState,
  DefaultTrackerSinglePlanState,
  DefaultTrackerSingleTimeLineViewState
} from '../reducers/trackerModule_reducer'


const getTrackerId = (state, props) => {
  let trackerId = null
  if (props.shortcut && props.shortcut.target_id) {
    trackerId = props.shortcut.target_id
  } else {
    trackerId = props.match.params.trackerId
  }
  return trackerId
}

const getTrackerByIdState = (state, props) => {
  let trackerId = null
  if (props.shortcut && props.shortcut.target_id) {
    trackerId = props.shortcut.target_id
  } else {
    trackerId = props.match.params.trackerId
  }
  return state.tracker.byId[trackerId]
}

const getTrackerPlanState = createSelector(
  [getTrackerByIdState],
  (state) => {
    return (state || {}).planDetails || DefaultTrackerIdState
  }
)

const getTrackerTimelineViewState = createSelector(
  [getTrackerByIdState],
  (state) => {
    return (state || {}).timelineView || DefaultTrackerIdState
  }
)

const getAverageBenchMarkTrackerPlanState = createSelector(
  [getTrackerByIdState],
  (state) => {
    return (state || {}).averagePlanDetails || DefaultTrackerIdState
  }
)

const getAverageBenchMarkTrackerTimelineViewState = createSelector(
  [getTrackerByIdState],
  (state) => {
    return (state || {}).averageTimelineView || DefaultTrackerIdState
  }
)

const getSelectedSingleTrackerEntity = createSelector(
  [getTrackerByIdState],
  (state) => {
    return (state || {}).selectedSingleTrackerEntity || null
  }
)

const getSingleTrackerPlanState = createSelector(
   [getSelectedSingleTrackerEntity, getTrackerByIdState],
   (selectedSingleTrackerEntity, trackerByIdState) => {
    if (selectedSingleTrackerEntity && trackerByIdState && (trackerByIdState.byTrackerEntityId[selectedSingleTrackerEntity] || {}).singleTrackerPlanDetails) {
      return (trackerByIdState.byTrackerEntityId[selectedSingleTrackerEntity] || {}).singleTrackerPlanDetails
     }
     return DefaultTrackerSinglePlanState
   }
 )

 const getSingleTrackerTimelineViewState = createSelector(
   [getSelectedSingleTrackerEntity, getTrackerByIdState],
   (selectedSingleTrackerEntity, trackerByIdState) => {
     if (selectedSingleTrackerEntity && trackerByIdState && (trackerByIdState.byTrackerEntityId[selectedSingleTrackerEntity] || {}).singleTrackerTimelineView) {
       return (trackerByIdState.byTrackerEntityId[selectedSingleTrackerEntity] || {}).singleTrackerTimelineView
     }
     return DefaultTrackerSingleTimeLineViewState
   }
 )


const getTrackerPrimaryEntityState = createSelector(
  [getTrackerByIdState],
  (state) => {
    return (state || {}).primaryEntity || DefaultTrackerPrimaryEntityState
  }
)

const getSelectedTrackerEntity = createSelector(
  [getTrackerByIdState],
  (state) => {
    return (state || {}).selectedTrackerEntity || null
  }
)

const getTrackerTeasersAndTrailersState = createSelector(
  [getSelectedTrackerEntity, getTrackerByIdState],
  (selectedTrackerEntity, trackerByIdState) => {
    if (selectedTrackerEntity && trackerByIdState) {
      return (trackerByIdState.byTrackerEntityId[selectedTrackerEntity] || {}).teasersAndTrailers
    }
    return DefaultTrackerTeasersAndTrailersState
  }
)

const getTrackerpageWhatsNewState = createSelector(
  [getSelectedTrackerEntity, getTrackerByIdState],
  (selectedTrackerEntity, trackerByIdState) => {
    if (selectedTrackerEntity && trackerByIdState) {
      return (trackerByIdState.byTrackerEntityId[selectedTrackerEntity] || {}).whatsNew
    }
    return DefaultWhatsNewState
  }
)

const getTrackerpageWordCloudState = createSelector(
  [getSelectedTrackerEntity, getTrackerByIdState],
  (selectedTrackerEntity, trackerByIdState) => {
    if (selectedTrackerEntity && trackerByIdState) {
      return (trackerByIdState.byTrackerEntityId[selectedTrackerEntity] || {}).wordCloud
    }
    return DefaultWhatsNewState
  }
)

const getTeaserAndTrailerState = createSelector(
  [getTrackerByIdState],
  (trackerByIdState) => {
    if (trackerByIdState) {
      return (trackerByIdState.byTrackerEntityId || {})
    }
    return {}
  }
)

const makeTeaserAndTrailerState = () => {
  return createSelector(
    [getTeaserAndTrailerState],
    teasersAndTrailers => {
      return teasersAndTrailers
    }
  )
}

const makeTrackerIdSelector = () => {
  return createSelector(
    [getTrackerId],
    topicId => {
      return topicId
    }
  )
}

const makeTrackerPlanSelector = () => {
  return createSelector(
    [getTrackerPlanState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeTrackerTimelineViewSelector = () => {
  return createSelector(
    [getTrackerTimelineViewState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeTrackerPrimaryEntitySelector = () => {
  return createSelector(
    [getTrackerPrimaryEntityState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeTrackerTeasersAndTrailersSelector = () => {
  return createSelector(
    [getTrackerTeasersAndTrailersState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeTrackerpageWhatsNewSelector = () => {
  return createSelector(
    [getTrackerpageWhatsNewState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeTrackerpageWordCloudSelector = () => {
  return createSelector(
    [getTrackerpageWordCloudState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeAverageBenchMarkTrackerPlanSelector = () => {
  return createSelector(
    [getAverageBenchMarkTrackerPlanState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeAverageBenchMarkTrackerTimelineViewSelector = () => {
  return createSelector(
    [getAverageBenchMarkTrackerTimelineViewState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeSingleTrackerPlanSelector = () => {
  return createSelector(
    [getSingleTrackerPlanState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeSingleTrackerTimelineViewSelector = () => {
  return createSelector(
    [getSingleTrackerTimelineViewState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

export {
  makeTrackerIdSelector,
  makeTrackerPlanSelector,
  makeTrackerTimelineViewSelector,
  makeTrackerPrimaryEntitySelector,
  makeTrackerTeasersAndTrailersSelector,
  makeTrackerpageWhatsNewSelector,
  makeTrackerpageWordCloudSelector,
  makeTeaserAndTrailerState,
  makeAverageBenchMarkTrackerPlanSelector,
  makeAverageBenchMarkTrackerTimelineViewSelector,
  makeSingleTrackerPlanSelector,
  makeSingleTrackerTimelineViewSelector
}
